import styled, { css } from 'styled-components';
import { TabContainer, TabRow } from '../Tabs-styled';


export const WidthThicknessTabRow = styled(TabRow)`
  margin-top: 20px;
`;

export const DimensionsTabContainer = styled(TabContainer)`
  ${(props) => props.mobile && css`
    ${WidthThicknessTabRow} {
      margin-top: ${20 * props.menuScaleFactor}px;
    }
  `};
`; 